import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable()
export class NoopInterceptor implements HttpInterceptor {
  constructor(private ngxSpinnerService: NgxSpinnerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.startsWith("http://") || req.url.startsWith("https://")) {
      if (
        req.url.indexOf("/Sanciones/Crear") < 0 &&
        req.url.indexOf("/NotificacionesMasivasAdministrador/RedactarMensaje") < 0 &&
        req.url.indexOf("/Archivo/SubirDocumento") < 0 &&
        req.url.indexOf("/DocumentoDetalleSolicitud") < 0 &&
        req.url.indexOf("/sanciones/CambiarEstadoSancion") < 0 &&
        req.url.indexOf("/Encuesta/AlmacenarRespuestasPorPregunta") < 0 &&
        req.url.indexOf("/DetalleSolicitudDatosAdicionales/Actualizar") < 0
      ) {
        this.ngxSpinnerService.show();
      }
    }
    return next.handle(req);
  }
}
